$(document).ready(function() {
   /* fixed header menu js starts */
    $(window).on('scroll', function(){
        if ($(window).scrollTop() > $('#bottom-nav').height()){
            $('#bottom-nav').addClass('fixed-menu');
        }else {
            $('#bottom-nav').removeClass('fixed-menu');
        }
    })
 
    /* fixed header menu js ends */


  /* fixed header menu js starts */
    $(window).on('scroll', function(){
        if ($(window).scrollTop() > $('.mobile-menu').height()){
            $('.mobile-menu').addClass('fixed-menu');
        }else {
            $('.mobile-menu').removeClass('fixed-menu');
        }
    })
 
    /* fixed header menu js ends */

  
     /* scroll top button js starts */
    $('.back_to_top').on('click', function () {
        $('html,body').animate({
            scrollTop: 0,
        },1000)
       return false;
    })
    /* scroll top button js ends */
    /* picnic slider */
        /* slider */
    if( $('.picnic-slider-wrapper').length > 0 ){
       $('.picnic-slider-wrapper').slick({
            prevArrow: '.left-arrow',
            nextArrow: '.right-arrow',
            dots: false,
            autoplay: true,
            autoplaySpeed: 2000,
        });
        $(".slider-arrow .text-blocks .text").first().show();
        $('.picnic-slider-wrapper').on('afterChange', function(event, slick, currentSlide, nextSlide){
            var dataId = currentSlide;  
            console.log(dataId);
            $('.slider-arrow .text-blocks .text').hide();
            $(".slider-arrow .text-blocks .text:eq(" + dataId + ")").show();
        });
    }
       
  
    
        /* slider */
    /* picnic slider */
   /* mobile menu js starts here */
  $('.toggle-btn-mobile').on('click', function () {
    $(this).toggleClass('active');
    $('.mobile-menu .navbar-nav').toggleClass('active');
  }); 
  $('.nav-arrow').on('click', function () {
    $(this).toggleClass('active');
    $(this).next('.collapse').toggleClass('active');
  }); 
  /* mobile menu js ends here */

  
         
});



              /* active menu */
/*  const activePage = window.location.pathname;
  const navLinks = document.querySelectorAll('.navbar-nav a').forEach(link=> {
   if(link.href.includes(`${activePage}`)) {
    link.classList.add('active');
   }
   
  }) */
  /* active menu */
